import React from 'react';
import { connect } from 'react-redux';
import ListAnimation from '../../../utils/animations/list';

const mapStateToProps = (state) => {
	const { rightFeedbackProps, answerCount } = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
	};
};

const MsIncorrect = ({
	rightFeedbackProps: {
		feedbackChoices,
		feedbackImageChoices,
		correctAnswer,
		userAnswer,
		score,
	},
}) => {
	let Choicelist = '';
	if (!!feedbackChoices) {
		if (!!feedbackChoices && Object.keys(feedbackChoices).length > 0) {
			Choicelist = Object.keys(feedbackChoices).map(function (choice) {
				if (feedbackChoices[choice] === '') {
					return false;
				}
				let TxtImgChoice = feedbackChoices[choice];
				if (
					feedbackImageChoices[choice] !== '' &&
					feedbackImageChoices[choice] !== 'None'
				) {
					TxtImgChoice = <img src={feedbackImageChoices[choice]} alt="" />;
				}

				let choicefb = feedbackChoices[choice].toLowerCase().trim();
				let answerfb = userAnswer.toLowerCase().trim();
				let correctfb = correctAnswer.toLowerCase().trim();

				let feedbackClass = 'wrong-answer-ms';
				let checked = false;
				if (correctfb.includes(choicefb) && score < 0) {
					feedbackClass = 'radio-blue';
				} else if (correctfb.includes(choicefb) && answerfb.includes(choicefb)) {
					feedbackClass = 'possible-answer';
					checked = true;
				} else if (correctfb.includes(choicefb)) {
					feedbackClass = 'possible-answer';
				} else if (answerfb.includes(choicefb) && score < 1) {
					feedbackClass = 'wrong-answer-ms active';
					checked = true;
				}
				return (
					<li key={feedbackChoices[choice]} className={feedbackClass}>
						<input
							className="check-field"
							defaultChecked={checked}
							type="checkbox"
							name={choicefb}
							value={choicefb}
						/>
						<label htmlFor={choicefb}> {TxtImgChoice}</label>
					</li>
				);
			});
		}

		// appendScript('testMCQ');
	}

	return (
		<ListAnimation>
			<ul className="no-mouse-events quiz-area-options multiple-ops">
				{Choicelist}
			</ul>
		</ListAnimation>
	);
};

export default connect(mapStateToProps)(MsIncorrect);
